import { bool, func, object } from 'prop-types'
import { Box } from '@mui/material'
import { ICONE } from 'icons'
import { BasePopover, usePopover } from 'feedback'
import { BaseGridLayout, BaseScatola } from 'layout'
import { BaseButtons } from './BaseButtons'

const COLORI = [
  { color: 'rgb(0, 0, 0)' },
  { color: 'rgb(77, 77, 77)' },
  { color: 'rgb(153, 153, 153)' },
  { color: 'rgb(230, 230, 230)', borderColor: 'rgb(153, 153, 153)' },
  { color: 'rgb(255, 255, 255)', borderColor: 'rgb(153, 153, 153)' },
  { color: 'rgb(230, 76, 76)' },
  { color: 'rgb(230, 153, 76)' },
  { color: 'rgb(230, 230, 76)' },
  { color: 'rgb(153, 230, 76)' },
  { color: 'rgb(76, 230, 76)' },
  { color: 'rgb(76, 230, 153)' },
  { color: 'rgb(76, 230, 230)' },
  { color: 'rgb(76, 153, 230)' },
  { color: 'rgb(76, 76, 230)' },
  { color: 'rgb(153, 76, 230)' },
]

BaseColorPicker.propTypes = {
  onColoreScelto: func,
  disabled: bool,
  propsBottone: object,
}

export default function BaseColorPicker(props) {
  const { onColoreScelto, disabled, propsBottone } = props

  const { popoverRef, openPopover, closePopover } = usePopover()

  return (
    <>
      <BaseButtons.Custom
        testo='Scegli colore'
        iconaInizio={ICONE.PENNELLO}
        onClick={openPopover}
        variant='outlined'
        color='info'
        {...(disabled && { disabled: true })}
        {...propsBottone}
      />

      <BasePopover ref={popoverRef}>
        <BaseScatola centraContenuto info sx={{ p: 1 }}>
          <BaseGridLayout spacing={1}>
            {COLORI.map(({ color, borderColor }) =>
              <Box
                key={color}
                sx={{
                  width: 20,
                  height: 20,
                  cursor: 'pointer',
                  bgcolor: color,
                  borderRadius: 1,
                  ...(borderColor && { border: 1, borderColor }),
                }}
                onClick={() => {
                  onColoreScelto(color)
                  closePopover()
                }}
              />
            )}
          </BaseGridLayout>
        </BaseScatola>
      </BasePopover>
    </>
  )
}